import { render, staticRenderFns } from "./TransferFundsOwnAccountPayeeList.vue?vue&type=template&id=5ef611e4"
import script from "./TransferFundsOwnAccountPayeeList.vue?vue&type=script&lang=js"
export * from "./TransferFundsOwnAccountPayeeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports